import styled from '@emotion/styled'

import { colors, palette, spacing, Text } from 'main/ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const ItemsContainer = styled.div`
  border: 1px solid ${colors.border.default};
  border-radius: 3px;
  display: flex;
  flex-direction: row;

  > :not(:last-child) {
    border-right: 1px solid ${colors.border.default};
  }
`

interface IItemProps {
  selected: boolean
}

export const ItemContainer = styled.div<IItemProps>`
  align-items: center;
  background-color: ${({ selected }) => (selected ? palette.skyBlue2 : 'transparent')};
  cursor: pointer;
  display: flex;
  flex-basis: 0;
  flex-direction: column;
  flex-grow: 1;
  height: 55px;
  justify-content: center;
`

export const Label = styled(Text)<IItemProps>`
  color: ${({ selected }) => (selected ? palette.white : palette.slate)};
`

export const Error = styled(Text)`
  color: ${colors.text.error};
  margin-top: ${spacing.majorScale(1)}px;
`
